<div class="modal-backdrop" *ngIf="loading">
  <div class="loader-container">
    <div class="loading-overlay-spinner"></div>
    <!-- <img src="assets/images/horizons-logo.png" alt=""> -->
  </div>
</div>
